import { useEffect, useState } from 'react';
import { createApiGateway } from '../apiGateway';

const apiGateway = createApiGateway();

let cachedCols: string[] | null = null;

export function useExtraCols() {
  const [extraCols, setExtraCols] = useState<string[]>(cachedCols || []);
  const [loading, setLoading] = useState(cachedCols === null);

  useEffect(() => {
    if (cachedCols !== null) {
      return;
    }

    let isMounted = true;

    (async () => {
      try {
        const cols = await apiGateway.statisticsV2.getExtraCols();
        cachedCols = cols;
        if (isMounted) {
          setExtraCols(cols);
        }
      } catch {
        // Keep empty array on error
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  return { extraCols, loading };
}
